import React from "react";
import { useTranslation } from "react-i18next";
import { RestaurantFeatureFlagEditor } from "../features/feature-flags/Editor";
import { withRestaurantId } from "../shared/components/layout";

const RestaurantFeatureFlagEditorWithId = withRestaurantId(RestaurantFeatureFlagEditor);

const RestaurantFeatureFlagPage: React.FC = () => {
  const { t } = useTranslation();

  return <RestaurantFeatureFlagEditorWithId />;
};

export default RestaurantFeatureFlagPage;
